export function svgInject(svgURL: string) {
    const request = new XMLHttpRequest();

    request.open('GET', svgURL, true);
    request.onload = function() {
        if (request.status >= 200 && request.status < 400) {
            let data = request.responseText;

            // Create node with response data and insert into DOM
            let div = document.createElement('div');
            div.innerHTML = data;
            document.body.insertBefore(div, document.body.childNodes[0]);
        } else {
            console.log('Could not load SVG sprite');
        }
    };
    request.onerror = function() {
        console.log('Issue loading SVG sprite - connection error');
    };
    request.send();
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/svg-injection.ts